const getCSSRulePropertiesCamelCase = (shadowRoot, className) => {
    const sheets = shadowRoot.styleSheets;
    for (let i = 0; i < sheets.length; i++) {
        const sheet = sheets[i];
        if (sheet.href && !sheet.href.startsWith(window.location.origin)) {
            continue;
        }
        try {
            const rules = sheet.cssRules || sheet.rules;
            if (!rules) {
                continue;
            }
            for (let j = 0; j < rules.length; j++) {
                const rule = rules[j];
                if (rule.selectorText === '.' + className) {
                    const properties = {};
                    const style = rule.style;
                    // convert to camelcase
                    for (let k = 0; k < style.length; k++) {
                        const propertyName = style[k];
                        const camelCaseName = propertyName.replace(/-([a-z])/g, (g) => g[1].toUpperCase());
                        properties[camelCaseName] = style.getPropertyValue(propertyName);
                    }
                    return properties;
                }
            }
        }
        catch (e) {
            continue;
        }
    }
    return null;
};
const isIncludeCSSRuleProperties = (shadowRoot, className, styles) => {
    const properties = getCSSRulePropertiesCamelCase(shadowRoot, className);
    // console.log('00---00>', className, properties);
    if (!properties) {
        return false;
    }
    let allPass;
    for (const s in styles) {
        const v = styles[s];
        const originalProp = properties[s];
        allPass = v === originalProp;
        continue;
    }
    return allPass;
};
export const modifyCSSRuleMultiple = (shadowRoot, className, validateStyles, styles) => {
    const sheets = shadowRoot.styleSheets;
    // check the right class
    const isValid = isIncludeCSSRuleProperties(shadowRoot, className, validateStyles);
    if (!isValid) {
        return false;
    }
    // start to modify
    for (let i = 0; i < sheets.length; i++) {
        try {
            const rules = sheets[i].cssRules || sheets[i].rules;
            if (!rules)
                continue;
            for (let j = 0; j < rules.length; j++) {
                const rule = rules[j];
                if (rule.selectorText === '.' + className) {
                    Object.assign(rule.style, styles);
                    return true;
                }
            }
        }
        catch (e) {
            console.log(`Can't read stylesheet:`, e);
        }
    }
    return false;
};
